// Tryb — the certification badge.
//
// Thirty-one promises about how the room is run. None of them gate publishing;
// all of them gate the badge, which is what moves a listing up in search.

import { Card, InkCard, Meter, Overline, SectionTitle } from "../../components/Card.jsx";
import { FieldCell } from "../../components/TrybField.jsx";
import { useStudio } from "../../lib/studioContext.js";
import { useFieldViews } from "../../lib/useFieldViews.js";
import { certificationGroups, certificationProgress, CERTIFICATION_TOTAL } from "../../lib/studioView.js";

export default function Certification() {
  const { vals } = useStudio();
  const { fieldViews } = useFieldViews();

  const cert = certificationProgress(vals);
  const groups = certificationGroups(vals, fieldViews);

  const headline =
    cert.done >= CERTIFICATION_TOTAL
      ? "You’re certified."
      : cert.done === 0
        ? "What turns a class into a tryb."
        : `${CERTIFICATION_TOTAL - cert.done} to go.`;

  return (
    <>
      <InkCard padding="28px 32px" style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 24, alignItems: "center" }}>
        <div>
          <Overline color="inherit" style={{ opacity: 0.65 }}>
            Certified facilitator badge
          </Overline>
          <div
            style={{
              fontFamily: "var(--font-display)",
              fontSize: "var(--text-2xl)",
              fontWeight: 800,
              letterSpacing: "var(--tracking-tight)",
              marginTop: 6,
              lineHeight: 1.1,
            }}
          >
            {headline}
          </div>
          <div style={{ fontSize: "var(--text-sm)", opacity: 0.8, marginTop: 8, lineHeight: 1.55, maxWidth: 560 }}>
            Thirty-one small promises about how you run the room. You don’t need any of them to publish. You need all of them for the badge —
            and the badge is what moves you up in search.
          </div>
          <Meter
            pct={cert.pct}
            color="var(--honey-500)"
            track="color-mix(in srgb, var(--sand-75) 18%, transparent)"
            style={{ marginTop: 18, maxWidth: 420 }}
          />
        </div>
        <div style={{ textAlign: "center", padding: "0 12px" }}>
          <div style={{ fontFamily: "var(--font-display)", fontSize: "var(--text-5xl)", fontWeight: 800, lineHeight: 1, color: "var(--honey-500)" }}>
            {cert.done}
          </div>
          <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, opacity: 0.7, marginTop: 6 }}>OF {CERTIFICATION_TOTAL}</div>
        </div>
      </InkCard>

      {groups.map((s) => (
        <Card key={s.id} padding={28}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <SectionTitle>{s.title}</SectionTitle>
            <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, color: "var(--text-muted)" }}>{s.progress}</span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
            {s.fields.map((f) => (
              <FieldCell key={f.id} f={f} />
            ))}
          </div>
        </Card>
      ))}
    </>
  );
}
